<mat-toolbar color="primary">
  <mat-toolbar-row>
    @if (contest.title) {
      <span>{{ contest.title }}</span>
    }
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto">
      <mat-icon (click)="closeDialogue()">close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (contest) {
  <app-show-contest-component [contest]="contest" [decision_table]="decision_table"/>
}
